"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var satcheljs_1 = require("satcheljs");
exports.default = satcheljs_1.createStore('messagePreviewOption', {
    showPreviewTextInListView: null,
})();
//# sourceMappingURL=store.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-message-preview-option/lib/store/store.js
// module id = 3072
// module chunks = 2